import React from "react"

import * as S from "./hero-home.styles"
import CustomImage from "../../components/custom-image/custom-image.component"
import Container from "@mui/material/Container"
import { Stack } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"
import Scooter from "../../assets/icons/noun-scooter-delivery.svg"

const HeroHome = ({ image }) => {
  return (
    <S.Wrapper>
      {image && <CustomImage img={image} />}
      <S.CustomContainer maxWidth="md">
        <Stack spacing={6} alignItems={"center"}>
          <S.Title>We are open</S.Title>
          <Stack direction="row" spacing={2}>
            <S.Button
              target="_blank"
              href="https://order.toasttab.com/online/halftimepizzaboston"
              className="red"
            >
              Pickup
            </S.Button>
            <S.Button
              target="_blank"
              href="https://www.doordash.com/store/halftime-pizza-boston-2479274/?gclid=CjwKCAjw9pGjBhB-EiwAa5jl3F_R2iZBX7n4fGVyLH52SxyiQgclxiKS5XtF5epkqlotELXSC0pvwhoCVr8QAvD_BwE&ignore_splash_experience=true&kclickid=_k_CjwKCAjw9pGjBhB-EiwAa5jl3F_R2iZBX7n4fGVyLH52SxyiQgclxiKS5XtF5epkqlotELXSC0pvwhoCVr8QAvD_BwE_k_&utm_adgroup_id=134724945499&utm_campaign=CX_US_SE_GP_GO_ACQ_RNEXXX_16529111909_RSTRNT_%20LA_ACQ_RESTR_LocalCampgnxx_EVG_CPAx_XXX_Y0394_EN_EN_X_DOOR_GO_SE_OLA_NoEst1xx8k&utm_content=134724945499&utm_creative_id=606141187608&utm_keyword_id=kwd-1020584556363&utm_medium=GPA_Ads&utm_source=Google&utm_term=f:aggregator_serp:feature_id_fprint=13828486542284027814"
              className="lightBorder"
            >
              <Scooter />
              Order Delivery
            </S.Button>
          </Stack>
        </Stack>
      </S.CustomContainer>
    </S.Wrapper>
  )
}

export default HeroHome
